import { Form } from 'antd';

import { StepWrapper } from '../../../styles';
import { ExamGroupsWarning } from '../../ExamGroupsWarning';
import { TranslatedTitle, TranslatedText } from '../components';

import { AutonomousCommunitySelector } from '@/components/Form';
import { ExamGroupSelector } from '@/components/Form/ExamGroupSelector/';
import { Box } from '@/components/Utils';
import { RULES } from '@/constants';
import { useOnboardingFormLogic } from '@/hooks';

export const DefineYourGoalOpos = () => {
  const { setExamGroupDate } = useOnboardingFormLogic();
  return (
    <StepWrapper>
      <TranslatedTitle i18nKey="DEFINE_YOUR_GOAL" />
      <Box flexDirection="column" gap={24}>
        <Box flexDirection="column" gap={12}>
          <TranslatedText i18nKey="AUTONOMOUS_COMMUNITY" />
          <Form.Item rules={[RULES.REQUIRED]} name={['userInfo', 'autonomousCommunity']}>
            <AutonomousCommunitySelector variant="outlined" />
          </Form.Item>
        </Box>
        <Box flexDirection="column" gap={12}>
          <TranslatedText i18nKey="EXAM_GROUP" />
          <Form.Item name={['userInfo', 'examGroups']} style={{ marginBottom: 0 }}>
            <ExamGroupSelector mode="multiple" onExamGroupSelect={setExamGroupDate} />
          </Form.Item>
          <ExamGroupsWarning />
        </Box>
      </Box>
    </StepWrapper>
  );
};
